import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { InitService } from 'src/app/core/init/init.service';
import { EspectaculosService } from '../../espectaculos-butacas/espectaculos.service';
import { ButacasService } from '../../espectaculos-butacas/mapa/servicios/butacas.service';
import { ProductosService } from '../../productos.service';
import { CalendarService } from '../../ticket-sales/pages/date-selector/calendar/calendar.service';
import { IEnlaceMenuPadre } from '../../productos.service.interface';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { UserService } from 'src/app/user/user.service';
import { VentaService } from 'src/app/core/services/venta.service';

@Component({
  selector: 'app-producto-padre-item',
  templateUrl: './producto-padre-item.component.html',
  styleUrls: ['./producto-padre-item.component.scss']
})
export class ProductoPadrItemComponent implements OnInit, OnDestroy {
  @Input() productoPadre: IEnlaceMenuPadre
  filtrarSub: Subscription;
  proyecto = this.config.getProyecto();
  backupProductosPadreSub: Subscription;
  backupProductosPadre: IEnlaceMenuPadre[];
  productosPadreSub: Subscription;
  productosPadre: IEnlaceMenuPadre[];
  configurationSub: Subscription;
  verAreaCliente: number = 0; // Variable para mostrar el área cliente, por defecto es 0 (no mostrar)
  loading: boolean = false;
  espectaculosConfig: any;

  todosProductosCat;
  productosCat = [];
  todosEspectaculosCat;
  espectaculosCat = [];

  constructor(
    private productosService: ProductosService,
    private config: AppConfiguration,
    private initService: InitService,
    private calendarService: CalendarService,
    private router: Router,
    private butacasService: ButacasService,
    private espectaculoService: EspectaculosService,
    private configurationService: ConfigurationService,
    private userService: UserService,
    private ventaService: VentaService
  ) {}

  ngOnInit(): void {
    
    this.configurationSub = this.configurationService.configuration$.subscribe(config => {
      if (config && config !== undefined && config !== null && config.datosProyecto) {
        this.verAreaCliente = this.configurationService.getCaracteristicasAdicionalesProyecto().MostrarAreaCliente || 0;
      }
    });

    this.productosPadreSub = this.productosService.enlacesMenuPadre$.subscribe(() => {
      this.productosPadre = this.productosService.enlacesMenuPadreValue;
    });

    this.backupProductosPadreSub = this.productosService.backupProductosPadre$.subscribe(() => {
      this.backupProductosPadre = this.productosService.backupProductosPadreValue;
    });

    this.filtrarSub = this.productosService.filtroProductos$.subscribe(filtro => {
      if (filtro && filtro.length > 0) {
        this.productosPadre = this.backupProductosPadre;
        this.productosPadre = this.productosPadre.filter(p => p.chNombre.toLowerCase().includes(filtro));
      } else {
        this.productosPadre = this.backupProductosPadre;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.backupProductosPadreSub) this.backupProductosPadreSub.unsubscribe();
    if (this.productosPadreSub) this.productosPadreSub.unsubscribe();
  }

  onImgError(event) {
    event.target.src = 'assets/img/' + this.proyecto + '/catalog-padre/default_catalog.png';
  }

  /* GETTERS & SETTERS */

  setTodosProductosCat(productos) {
    this.todosProductosCat = productos;
  }

  get todosProductosCatValue() {
    return this.todosProductosCat;
  }

  setProductosCat(productos) {
    this.productosCat = productos;
  }

  get productosCatValue() {
    return this.productosCat;
  }

  setTodosEspectaculosCat(espectaculos) {
    this.todosEspectaculosCat = espectaculos;
  }

  get todosEspectaculosCatValue() {
    return this.todosEspectaculosCat;
  }

  setEspectaculosCat(espectaculos) {
    this.espectaculosCat = espectaculos;
  }

  get espectaculosCatValue() {
    return this.espectaculosCat;
  }

  /* END GETTERS & SETTERS */


  openAccordion() {
    this.loading = true;
    this.loadProducts();
  }

  closeAccordion() {
    this.loading = false;
    this.resetValues();
  }

  loadProducts() {
    if (!this.initService.startedValue) {
      this.initService
        .getInitData()
        .pipe(
          mergeMap(() =>
            this.productosService
              .getTodosProductos(this.productoPadre.pkid)
              .pipe(
                map(res => {
                  if (res) {
                    this.setTodosProductosCat(res);
                    this.setProductosCat(
                      res.DictTarifasEntradas && Object.values(res.DictTarifasEntradas).length > 0
                        ? Object.values(res.DictTarifasEntradas)
                        : res.ListTarifasEntradas
                    );

                    this.loading = false;
                  } else {
                    this.loading = false;
                  }
                  return res;
                })
              )
          )
        )
        .pipe(
          mergeMap(res =>
            this.productosService
              .getTodosEspectaculos(this.productoPadre.pkid)
              .pipe(
                map(result => {
                  if (result && result.EspectaculosDisponible) {

                    this.setTodosEspectaculosCat(result);
                    this.setEspectaculosCat(result.EspectaculosDisponible);
                  } else {
                    this.loading = false;
                  }

                  if (!res) {
                    res = { res: null, result: null };
                  }

                  res.res = res;
                  res.result = result;
                  return res;
                })
              )
          )
        )
        .pipe(take(1))
        .subscribe(() => {
          this.espectaculosConfig = JSON.parse(
            this.configurationService.configurationValue.datosProyecto.CaracteristicasAdicionales
          ).CaracteristicasAdicionales.Espectaculos;
        });
    } else {
      this.espectaculosConfig = JSON.parse(
        this.configurationService.configurationValue.datosProyecto.CaracteristicasAdicionales
      ).CaracteristicasAdicionales.Espectaculos;

      this.productosService
        .getTodosProductos(this.productoPadre.pkid)
        .pipe(
          mergeMap((res: any) =>
            this.productosService
              .getTodosEspectaculos(this.productoPadre.pkid)
              .pipe(
                map(result => {
                  if (result && result.EspectaculosDisponible) {
                    this.setTodosEspectaculosCat(result);
                    this.setEspectaculosCat(result.EspectaculosDisponible);
                  }

                  if (!res) {
                    res = { res: null, result: null };
                  }

                  res.res = res;
                  res.result = result;
                  return res;
                })
              )
          )
        )
        .pipe(take(1))
        .subscribe((res: any) => {
          if (res.res) {

            this.setTodosProductosCat(res.res);
            this.setProductosCat(
              res.res.DictTarifasEntradas && Object.values(res.res.DictTarifasEntradas).length > 0
                ? Object.values(res.res.DictTarifasEntradas)
                : res.res.ListTarifasEntradas
            );

            this.loading = false;

          } else if (!res.result) {
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
    }
  }

  resetValues() {
    this.setTodosProductosCat([]);
    this.setProductosCat([]);
    this.setTodosEspectaculosCat([]);
    this.setEspectaculosCat([]);
  }
}
